import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchAdminCompany } from '@/api/(admin)/companies';

/**
 * One company, unscoped.
 *
 * A removed company used to be a separate resource (`/admin/companies-removed/
 * :id`); it is now the same endpoint with `removed=true`, so the caller's
 * `isRemoved` rides on the query rather than picking a different fetch
 * function — carried on the URL so a deep link to a removed company still
 * resolves.
 */
export function adminCompanyQueryOptions(
  companyId: string,
  isRemoved: boolean,
) {
  return queryOptions({
    queryKey: ['admin', 'companies', 'detail', companyId, isRemoved] as const,
    queryFn: () => fetchAdminCompany(companyId, isRemoved),
    staleTime: 60_000,
  });
}

export function useAdminCompany(companyId: string, isRemoved: boolean) {
  const query = useQuery(adminCompanyQueryOptions(companyId, isRemoved));
  return { ...query, company: query.data?.data };
}
